import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppMainComponent } from './modules/common/component';
import { AppNotfoundComponent } from './pages/notfound/app.notfound.component';
import { AppErrorComponent } from './pages/error/app.error.component';
import { AppAccessdeniedComponent } from './pages/access/app.accessdenied.component';
import { AppLoginComponent } from './pages/auth/login/app.login.component';
import { NoAuthGuard } from './modules/common/guards';
import { AppUnconfirmedComponent } from './pages/unconfirmed/app.unconfirmed.component';
import { ServerDownComponent } from './pages/server-down/server-down.component';
import { MsalGuard } from '@azure/msal-angular';
import { ManualLoginGuard } from './modules/common/guards/manual/manual-auth.guard';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '', redirectTo: 'login', pathMatch: 'full'
            },
            {
                path: 'user',
                component: AppMainComponent,
                canActivate:[ManualLoginGuard],
                children: [
                    {
                        path: '',
                        redirectTo: 'master-data',
                        pathMatch: 'full'
                    },
                    {
                        path: 'dashboard',
                        loadChildren: () => import('src/app/modules/user/dashboard/dashboard.module').then(m => m.DashboardModule)
                    },
                    {
                        path: 'search',
                        loadChildren: () => import('src/app/modules/user/documents/documents.module').then(m => m.DocumentsModule)
                    },
                    {
                        path: 'admin',
                        loadChildren: () => import('src/app/modules/user/administration/administration.module').then(m => m.AdministrationModule)
                    },
                    {
                        path: 'super-admin',
                        loadChildren: () => import('src/app/modules/user/super-administration/super-administration.module').then(m => m.SuperAdministrationModule)
                    },
                    {
                        path: 'master-data',
                        loadChildren: () => import('src/app/modules/user/master-data/master-data.module').then(m => m.MasterDataModule)
                    },
                    {
                        path: 'profile',
                        loadChildren: () => import('src/app/modules/profile/profile.module').then(m => m.ProfileModule)
                    }
                ]
            },
            { path: 'error', component: AppErrorComponent },
            { path: 'access', component: AppAccessdeniedComponent},
            { path: 'notfound', component: AppNotfoundComponent },
            { path: 'unconfirmed', component: AppUnconfirmedComponent },
            { path: 'server-down', component: ServerDownComponent },
            { path: 'login', component: AppLoginComponent,canActivate:[NoAuthGuard]},
            { path: '**', redirectTo: '/notfound' },
        ], { scrollPositionRestoration: 'enabled' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}